import * as Model from "@effect/sql/Model";
import { Schema } from "effect";
import { AgentChannelName } from "./AgentChannel.ts";
import { AgentPlatform } from "./AgentRelease.ts";

/**
 * AgentChannelHistory model — append-only forensics row written every
 * time the (channel, platform) pointer flips (current_release_id
 * change OR paused toggle).
 *
 * Maps 1:1 to the `agent_channel_history` table.
 *
 * @since 1.0.0
 */
export class AgentChannelHistory extends Model.Class<AgentChannelHistory>("AgentChannelHistory")({
  id: Model.Generated(Schema.String),
  channel: AgentChannelName,
  platform: AgentPlatform,
  previousReleaseId: Schema.NullOr(Schema.String),
  newReleaseId: Schema.NullOr(Schema.String),
  changedBy: Schema.String,
  changedAt: Model.DateTimeInsertFromDate,
  reason: Schema.NullOr(Schema.String),
}) {}
